import { render } from "./ButtonConfirmation.vue?vue&type=template&id=204b38f3"
import script from "./ButtonConfirmation.vue?vue&type=script&lang=js"
export * from "./ButtonConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__